import styled from '@emotion/styled';
import { alpha, Button, Stack } from '@mui/material';

import { Row } from '@dh/styles';
import { shouldForwardProps } from '@dh/utils';

const BaseFiltersButton = styled(Button)`
    min-width: 42px;
    height: 40px;
    color: ${({ theme }) => theme.colors.onSurfaceVariant};
    background-color: ${({ theme }) => theme.colors.surface};
    border-radius: ${({ theme }) => theme.spacing(1)};
    text-transform: none;

    &:focus {
        background-color: ${({ theme }) => theme.colors.primaryContainer};
        border: 2px solid ${({ theme }) => theme.colors.onSurface};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px ${({ theme }) => theme.colors.primaryContainer},
            0 0 0 4px ${({ theme }) => alpha(theme.colors.primary, 0.4)};
    }
`;

const OpenDetailedFiltersButton = styled(BaseFiltersButton, shouldForwardProps)<{
    hasExtraRightPadding: boolean;
}>`
    padding-right: ${({ hasExtraRightPadding, theme }) =>
        hasExtraRightPadding ? theme.spacing(1.5) : theme.spacing(1)};
`;

const FilterWrapper = styled(Stack)`
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

const FilterRow = styled(Row)`
    display: flex;
    gap: ${({ theme }) => theme.spacing(1)};
    flex-wrap: wrap;
`;

export { BaseFiltersButton, FilterWrapper, OpenDetailedFiltersButton, FilterRow };
